/**
 * Lista de ambientes da Marcenaria em cards (≤1024px) — redesenho mobile
 * do legado (2026-09-24, opção B). Substitui as 4 tabelas (Fila, Em
 * andamento, Bloqueados, Todos) abaixo de 1024px. Tocar no card abre o
 * painel do ambiente (datas + histórico de comentários), como a linha da tabela.
 *
 *   ┌──────────────────────────────────┐
 *   │ CLIENTE              ● No prazo  │
 *   │ Ambiente                         │
 *   │ lote 12 · marc. João · prazo …   │
 *   └──────────────────────────────────┘
 */
import React from "react";
import {
  CardItem,
  CardList,
  CardMeta,
  CardSub,
  CardTitulo,
  CardTopo,
  CardVazio,
} from "../../components/ListaCompacta/styles";
import { BalaoComentarios } from "../../components/HistoricoAmbiente";
import { formatarData } from "../../utils/calculos";

const VAZIO = "—";

// Ano com 2 dígitos na meta ("10/11/26").
export function dataCurta(valor) {
  const texto = formatarData(valor);
  return typeof texto === "string" ? texto.replace(/\/(\d{2})(\d{2})$/, "/$2") : texto;
}

function Meta({ pares }) {
  const visiveis = pares.filter(([, valor]) => valor != null && valor !== "" && valor !== VAZIO);
  if (!visiveis.length) return null;
  return (
    <CardMeta>
      {visiveis.map(([rotulo, valor], i) => (
        <span className="par" key={rotulo}>
          {i > 0 && <span className="sep">· </span>}
          <span className="k">{rotulo}</span> <b>{valor}</b>
        </span>
      ))}
    </CardMeta>
  );
}

/**
 * @param rows linhas já ordenadas
 * @param selo (row) => elemento do badge
 * @param barra (row) => tom da barra lateral
 * @param meta (row) => [[rotulo, valor], ...]
 * @param vazio texto do estado vazio
 * @param onAbrir (row) => void — toque no card
 */
export default function CardsAmbientes({ rows, selo, barra, meta, vazio, testId, onAbrir }) {
  if (!rows.length) {
    return (
      <CardList data-testid={testId}>
        <CardVazio>{vazio}</CardVazio>
      </CardList>
    );
  }
  return (
    <CardList data-testid={testId}>
      {rows.map((row) => (
        <CardItem
          key={`${row._origem || ""}-${row.index}`}
          $barra={barra(row)}
          data-testid="marcenaria-card"
          role={onAbrir ? "button" : undefined}
          tabIndex={onAbrir ? 0 : undefined}
          style={onAbrir ? { cursor: "pointer" } : undefined}
          onClick={onAbrir ? () => onAbrir(row) : undefined}
          onKeyDown={
            onAbrir
              ? (e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    onAbrir(row);
                  }
                }
              : undefined
          }
        >
          <CardTopo>
            <CardTitulo title={row.cliente}>{row.cliente}</CardTitulo>
            <span className="selo">{selo(row)}</span>
          </CardTopo>
          <CardSub title={row.ambiente}>
            {row.ambiente}
            {row.rowPlanilha && <BalaoComentarios row={row.rowPlanilha} />}
          </CardSub>
          <Meta pares={meta(row)} />
        </CardItem>
      ))}
    </CardList>
  );
}
